module.exports = "/packs/images/navigation/silver-device@3x-888b3b66b546d7b606d25b95ed6a496d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/silver-device@3x.jpg
// module id = 1813
// module chunks = 0